<template>
  <div class="process-container">
    <!-- <div class="process-title">
        <span></span>
        {{title}}
    </div> -->
    <div class="process-box">
        <img :src="`${require('@/assets/images/settledPlatform.png')}`" style="width:942px" alt="" srcset="">
        <!-- <template v-for="(item,index) in process">
            <div class="process-bar" :key="index">
                <img :src="item.icon" alt="">
                <div>
                    <p>{{item.title}}</p> -->
                    <!-- <span>{{item.intro}}</span> -->
                <!-- </div>
            </div>
            <span :key="index" v-if="index!==process.length-1" class="el-icon-arrow-right"></span>
        </template> -->
    </div>
  </div>
  <!-- <div style="margin-top:18px;"></div> -->
</template>

<script>
  export default {
    name: 'settledPlatform',
    data (){
        return{
            title:'商家采购流程',
            icon:'../../../../../static/image/settledIcon.png',
            process:[
                {
                    title:'提交企业认证资料',
                    intro:'约2小时',
                    icon:'../../../../../static/image/settled_step1.png'
                },
                {
                    title:'下采购订单',
                    intro:'3-6工作日',
                    icon:'../../../../../static/image/settled_step2.png'
                },
                {
                    title:'签署合同',
                    intro:'约10分钟',
                    icon:'../../../../../static/image/settled_step3.png'
                },
                {
                    title:'发货',
                    intro:'约20分钟',
                    icon:'../../../../../static/image/settled_step4.png'
                },
            ]
        }
    }
  }
</script>

<style lang="scss" scoped>
  >>>.layout{
      background-color: #F5F5F5 !important;
  }
  .process-container{
        box-shadow: 2px 2px 10px #cccccc59;
        
        position: absolute;
        bottom: 33px;
        left: 260px;
        // margin-left: -486.5px;
        background: #fff;
        display: flex;
        margin-top: 10px;
        width: 1034px;
        height: 97px;
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 18px;
        // padding: 0 18px 12px 18px;
        align-items: center;
        justify-content: center;
        .process-title{
            display: flex;
            align-items: center;
            // height: 61px;
            padding:6px 0 12px 0;
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            // img{
            //     display: inline-block;
            //     height: 30px;
            //     margin-right: 9px;
            // }
            span{
                display: block;
                width: 4px;
                height: 18px;
                margin-right: 9px;
                background: #F77B0B;
                border-radius: 2px;
            }
        }
        .process-box{
            display: flex;
            align-items: center;
            justify-content: space-around;
            .process-bar{
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                img{
                    display: inline-block;
                    height: 52px;
                    // margin-right: 38px;
                }
                &>div{
                    // height: 60px;
                    margin-top: 6px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    p{
                        font-size: 14px;
                        color: #000000;
                    }
                    // span{
                    //     font-size: 14px;
                    //     color: #666666;
                    // }
                }
            }
            .el-icon-arrow-right{
                font-size: 28px;
            }
        }
  }
 
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/cereshop/pc_b2c/settledPlatform.vue